'use strict'
module.exports = require('./lib')(require('./lib/js'))



//////////////////
// WEBPACK FOOTER
// ./~/secp256k1/js.js
// module id = 808
// module chunks = 0